module.exports = __webpack_public_path__ + "/images/cover-cta-lista.5d26b61.jpg";